import {
  message,
  Modal,
  PageHeader,
  Spin,
  Select,
  /*Form as FormInitial,*/
  Row,
  Col,
  Space,
  Tooltip,
  Switch,
  Typography,
  Input,
  Button,
  Checkbox
} from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Form,
  FormItem,
  SelectItem,
  InputNumberItem,
  dineroDisabledMask,
  round2Decimals,
  ButtonItem,
  round6Decimals,
  ErrorItem,
  DatePickerItem,
  InputItem,
  TextAreaItem,
  DisponibilidadInsumoModal,
} from "../../../../Components/Items";
import GeneralFormLayout from "../../../../Components/GeneralFormLayout";
import InfoCard from "../../../../Components/InfoCard";
import FilaInsumoOrdenDeCompra from "../../../../Components/FilaInsumoOrdenDeCompra";
import { PlusOutlined, ScheduleOutlined, SearchOutlined, InfoCircleOutlined, EnvironmentOutlined, CarOutlined, UserOutlined, PhoneFilled, /* FileExcelOutlined */ } from "@ant-design/icons";
import ElegirTipoDeProveedor from "../../Proveedores/ElegirTipoDeProveedor/ElegirTipoDeProveedor";
import MandarCorreoOrdenDeCompra from "../MandarCorreoOrdenDeCompra/MandarCorreoOrdenDeCompra";
import ElegirObservaciones from "../../Ventas/ElegirObservaciones/ElegirObservaciones";
import moment from "moment";
import AsignarInsumo from "../AsginarInsumo/AsignarInsumo";
import ModalInsumosSinRelacion from "../ModalInsumosSinRelacion/ModalInsumosSinRelacion";
import ModalCargarExcelOC from "../ModalCargarExcelOC/ModalCargarExcelOC";
import debounce from "lodash.debounce";
import intentarAprobarOrdenDeCompra from "../../../../Utils/intentarAprobarOrdenDeCompra";
import { calcularTotalesOC, grupoFamiliaDeFila } from "../../../../Utils/OrdenDeCompra.utils";
import EncabezadoFamiliaOC from "../../../../Components/EncabezadoFamiliaOC";
import {
  guardarBorradorOrdenDeCompra,
  leerBorradorOrdenDeCompra,
  borrarBorradorOrdenDeCompra,
} from "../../../../Utils/borradorOrdenDeCompra.utils";
import {
  aplicarDescuentoBaseAFila,
  costoParaDescuentoProveedor,
  normalizarDescuentoFila,
  sincronizarDescuentoFila,
} from "../../../../Utils/descuentoEscuela";

const { Option } = Select;

class AgregarOrdenDeCompra extends Component {
  formRef = React.createRef();
  state = {
    modalDisponibilidadVisible: false,
    insumoSeleccionadoDisponibilidad: { id: null, nombre: '' },
    modalCorreoId: null,
    modalCorreo: false,
    loading: false,
    objetoProveedores: null,
    todasProveedores: null,
    objetoProyectos: null,
    todasProyectos: null,
    objetoInsumos: (
      <Option disabled value={0} key={0}>
        Seleccione un proveedor primero
      </Option>
    ),
    objetoUsosDeCFDI: null,
    objetoFormasDePago: null,
    todasFormasDePago: null,
    impuestos: [],
    modalElegirTipoDeProveedor: false,
    modalElegirTipoDeProveedorId: null,
    modalElegirTipoDeProveedorNombre: null,
    modalObservaciones: false,
    modalObservacionesIndex: null,
    modalObservacionesObservaciones: null,
    modalObservacionesObservacionesPasadas: null,
    modalObservacionesObservacionesXml: null,
    proveedorExtranjero: false,
    proveedorId: null,
    modalAsignarInsumoVisible: false,
    proveedorSeleccionado: null,
    mostrarDetalles: true,
    verInsumosComoSistema: !!this.props.verComoSistemaOCPorDefecto,
    // Agrupa la tabla de insumos por familia con encabezados colapsables. Es
    // sólo una vista: NO reordena el arreglo `insumos`, así que el orden que se
    // guarda y se imprime es el de captura.
    agruparPorFamilia: false,
    enviarAprobacionAutomatica: true,
    numeracionPorSemana  : false,
    proyectosConSubproyectos : false,
    objetoSubproyectos : null,
    insumosSinRelacion : [],
    modalSinRelacionVisible : false,
    modalCargarExcelVisible: false,
    insumoIdRelacionando: null, 
    insumoDataRelacionando : null, 
     // Para la barra de busqueda 
    busquedaInsumo: "",
    insumoResaltado: null,
    proveedorIdActual: null, 
    nombreProveedorActual: null
  };
  async componentDidMount() {
    await this.consultarTodo();
    this.revisarBorradorGuardado();
  }

  // Si se sale de la pantalla antes de que corra el debounce, se escribe ya,
  // mientras el form sigue montado y guardarBorrador todavía puede leerlo.
  componentWillUnmount() {
    this.guardarBorrador.flush();
  }

  // Se dispara con cada cambio en el form (onValuesChange); debounced para no
  // escribir en localStorage en cada tecleo. Se quita "insumoCompleto" de cada
  // fila (el objeto pesado del catálogo, no hace falta para reanudar los
  // precios/cantidades) para que ordenes con muchos insumos no tarden en
  // serializarse, y la escritura se agenda en tiempo libre del navegador para
  // no competir con la interacción del usuario.
  //
  // Se lee el form al dispararse y no los valores que entregó onValuesChange:
  // rc-field-form llama onValuesChange ANTES del onChange del input, o sea antes
  // de que onChangePrecioCantidadDescuento recalcule la fila, y ese snapshot trae
  // la cantidad nueva con subtotal/impuestos/total de la tecla anterior.
  guardarBorrador = debounce((valoresEvento) => {
    const valores = this.formRef.current?.getFieldsValue() || valoresEvento;
    const valoresLigeros = {
      ...valores,
      insumos: (valores.insumos || []).map((fila) => {
        if (!fila) return fila;
        const { insumoCompleto, ...resto } = fila;
        return resto;
      }),
    };
    const escribir = () => guardarBorradorOrdenDeCompra(this.props.empresaId, valoresLigeros);
    if (typeof window.requestIdleCallback === "function") {
      window.requestIdleCallback(escribir);
    } else {
      setTimeout(escribir, 0);
    }
  }, 600);

  onValoresCambiaron = (changedValues, allValues) => {
    this.guardarBorrador(allValues);
  };

  revisarBorradorGuardado = () => {
    const datosPrecargados = this.props.location?.state?.datosPrecargados;
    if (datosPrecargados?.vieneDeEcommerce) return;

    const borrador = leerBorradorOrdenDeCompra(this.props.empresaId);
    if (!borrador) return;

    Modal.confirm({
      title: "Orden de compra sin terminar",
      content: `Tienes una orden de compra que no terminaste de registrar (guardada el ${moment(
        borrador.timestamp
      ).format("DD/MM/YYYY HH:mm")}). ¿Deseas continuar con ella?`,
      okText: "Sí, continuar",
      cancelText: "No, descartar",
      onOk: () => this.restaurarBorradorGuardado(borrador.valores),
      onCancel: () => borrarBorradorOrdenDeCompra(this.props.empresaId),
    });
  };

  restaurarBorradorGuardado = (valores) => {
    const proveedor = this.state.todasProveedores?.find(
      (p) => p._id === valores.proveedorId
    );
    if (proveedor) {
      this.setState({
        proveedorId: proveedor._id,
        proveedorSeleccionado: proveedor,
        proveedorExtranjero: proveedor.proveedorExtranjero || false,
      });
    }

    const proyecto = this.state.todasProyectos?.find(
      (p) => p._id === valores.proyectoId
    );
    if (proyecto) {
      if (Array.isArray(proyecto.subProyectos) && proyecto.subProyectos.length > 0) {
        this.setState({
          proyectosConSubproyectos: true,
          objetoSubproyectos: proyecto.subProyectos.map((sp) => (
            <Option key={sp._id} value={sp._id}>
              {sp.codigo + " - " + sp.nombre}
            </Option>
          )),
        });
      }
      if (proyecto.numeracionOrdenesSemana) {
        this.setState({ numeracionPorSemana: true });
      }
    }

    this.formRef.current.setFieldsValue({
      ...valores,
      fechaEntrega: valores.fechaEntrega ? moment(valores.fechaEntrega) : undefined,
      insumos: (valores.insumos || []).map((fila) => (fila ? {
        ...fila,
        fechaEntrega: fila.fechaEntrega ? moment(fila.fechaEntrega) : undefined,
      } : fila)),
    });

    message.success("Se restauró la orden de compra que no habías terminado.");

    this.recargarInsumosCompletos(valores.proveedorId, valores.insumos);
  };

  // Como se guardó el borrador sin "insumoCompleto" (ver guardarBorrador), aquí se
  // vuelve a pedir el catálogo de cada insumo único, en paralelo, y se rellena ese
  // campo por fila. precioUnitario/cantidad/descuento se respetan tal cual vienen
  // del borrador: no reutiliza onChangeInsumo/recargarInsumoEditado porque esos
  // reponen el precio del catálogo.
  //
  // Lo que SÍ se recalcula con calcularCamposFila es lo derivado (subtotal,
  // impuestos, total, arrayImpuestos, retenciones): un borrador puede traer la
  // fila tecleada con los importes de la tecla anterior (ver guardarBorrador), y
  // restaurarla tal cual guardaba una O/C cuyo importe no era cantidad × precio.
  recargarInsumosCompletos = async (proveedorId, insumos) => {
    if (!proveedorId || !insumos?.length) return;

    const idsUnicos = [...new Set(insumos.map((fila) => fila?.insumoId).filter(Boolean))];
    if (!idsUnicos.length) return;

    const resultados = await Promise.all(
      idsUnicos.map((insumoId) =>
        axios
          .post(
            "insumos/selectInsumosRelacionesProveedor",
            { empresaId: this.props.empresaId, proveedorId, query: insumoId, skip: 0 },
            { headers: this.props.headersToken }
          )
          .then((res) => ({ insumoId, insumoCompleto: res.data.insumos?.[0] || null }))
          .catch(() => ({ insumoId, insumoCompleto: null }))
      )
    );

    const mapaInsumos = new Map(resultados.map((r) => [r.insumoId, r.insumoCompleto]));
    // calcularCamposFila busca el proveedor en el catálogo para las retenciones;
    // si el del borrador ya no está, se recalcula sin retenciones en vez de tronar.
    const proveedorVigente = this.state.todasProveedores?.some((p) => p._id === proveedorId)
      ? proveedorId
      : undefined;
    const insumosActuales = this.formRef.current.getFieldValue("insumos") || [];
    const insumosActualizados = insumosActuales.map((fila) => {
      const insumoCompleto = fila?.insumoId && mapaInsumos.get(fila.insumoId);
      return insumoCompleto
        ? this.calcularCamposFila({ ...fila, insumoCompleto }, proveedorVigente)
        : fila;
    });
    this.formRef.current.setFieldsValue({ insumos: insumosActualizados });
  };

  abrirDisponibilidad = (insumoId, nombre, proyectoId) => {
    this.setState({ modalDisponibilidadVisible: true, insumoSeleccionadoDisponibilidad: { id: insumoId, nombre, proyectoId } });
  };

  cerrarDisponibilidad = () => {
    this.setState({ modalDisponibilidadVisible: false });
  };

  abrirModalCorreo(ordenId) {
    this.setState({ modalCorreo: true, modalCorreoId: ordenId });
  }

  cerrarModalCorreo() {
    this.setState({ modalCorreo: false, modalCorreoId: null });
    this.atras();
  }

  promisedSetState = (newState) =>
    new Promise((resolve) => this.setState(newState, resolve));

  async consultarTodo() {
    this.setState({ loading: true });
    const res = await axios.post(
      "ordenesdecompra/selectDatosParaOrdenDeCompra",
      { empresaId: this.props.empresaId },
      { headers: this.props.headersToken }
    );

    let newState = { loading: false };

    if (res.data.proveedores) {
      newState.todasProveedores = res.data.proveedores;
      newState.objetoProveedores = res.data.proveedores.map((value) => (
        <Option value={value._id} key={value._id}>
          {value.stringBuscar}
        </Option>
      ));
    }

    if (res.data.proyectos) {
      newState.todasProyectos = res.data.proyectos;
      newState.objetoProyectos = res.data.proyectos.map((value) => (
        <Option value={value._id} key={value._id}>
          {value.nombre}
        </Option>
      ));
    }

    if (res.data.monedas) {
      newState.todasMonedas = res.data.monedas;
      newState.objetoMonedas = res.data.monedas.map((value) => (
        <Option value={value._id} key={value._id}>
          {value.nombre + " - " + value.abreviacion}
        </Option>
      ));
    }

    if (res.data.usosDeCFDI) {
      newState.objetoUsosDeCFDI = res.data.usosDeCFDI.map((value) => (
        <Option value={value._id} key={value._id}>
          {value.c_UsoCFDI + " - " + value.descripcion}
        </Option>
      ));
    }

    if (res.data.formasDePago) {
      newState.todasFormasDePago = res.data.formasDePago;
      newState.objetoFormasDePago = res.data.formasDePago.map((value) => (
        <Option value={value._id} key={value._id}>
          {value.c_FormaPago + " - " + value.descripcion}
        </Option>
      ));
    }

    await this.promisedSetState(newState);
    this.cargarDatosDeEcommerce();
  }
  atras() {
    this.props.history.goBack();
  }
  onFinishFailed(e) {
    ErrorItem(e);
  }
  onFinish(values) {
    this.setState({ loading: true });
    const {
      subtotal,
      total,
      cuentasProveedor,
      totalPagar,
      arrayImpuestos,
      arrayRetenciones,
    } = calcularTotalesOC(values.insumos, { ignorarIncompletos: false });
    axios
      .post(
        "ordenesdecompra/agregarOrdenDeCompra",
        {
          ...values,
          empresaId: this.props.empresaId,
          total,
          subtotal,
          cuentasProveedor,
          totalPagar,
          arrayImpuestos,
          arrayRetenciones,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success(
            "Se ha registrado una orden de compra con codigo: " +
              res.data.codigo
          );
          // Sin cancelar, un guardado del borrador aún pendiente lo vuelve a crear
          // después de borrarlo (y el flush de componentWillUnmount también).
          this.guardarBorrador.cancel();
          borrarBorradorOrdenDeCompra(this.props.empresaId);

          const datosPrecargados = this.props.location?.state?.datosPrecargados;
          if (datosPrecargados?.vieneDeEcommerce && datosPrecargados?.ventaId) {
            axios.post(
              "ventasEcommerce/agregarOrdenDeCompraVenta",
              {
                ventaId: datosPrecargados.ventaId,
                ordenDeCompra: res.data.codigo,
                ordenDeCompraId : res.data.ordenId, 
                empresaId: this.props.empresaId,
              },
              { headers: this.props.headersToken }
            ).then((resVenta) => {
              if (resVenta.data.success === 2) {
                message.success("Venta vinculada con la orden de compra.");
              }
            });
          }
          if (res.data.aprobada){
            this.abrirModalCorreo(res.data.ordenId);
          } else {
            if (this.props.autorizacionesRapidas && this.state.enviarAprobacionAutomatica) {
              intentarAprobarOrdenDeCompra({
                ordenId: res.data.ordenId,
                empresaId: this.props.empresaId,
                headersToken: this.props.headersToken,
                folio: res.data.codigo,
                monto: total,
              });
            }
            this.atras();
          }


          this.formRef.current.resetFields();
        } else if (res.data.success === 1) {
          message.error(res.data.message || "No se puede registrar la orden de compra");
        } else {
          message.error("Hubo un error y la orden de compra no se registro");
        }
      });
  }
 
  // Escribe una sola fila de "insumos" dándole una identidad nueva solo a esa fila
  // (las demás conservan su referencia), para que los shouldUpdate acotados por fila
  // puedan detectar el cambio. No mutar el array/objeto que ya viene mutado desde afuera:
  // aquí solo se hace la copia final antes de escribir al store.
  aplicarFila(key, arrayValue) {
    const nuevoArray = arrayValue.slice();
    nuevoArray[key] = { ...arrayValue[key] };
    this.formRef.current.setFields([{ name: "insumos", value: nuevoArray }]);
  }

  // Cálculo puro de precioUnitarioConImpuestos/subtotal/impuestos/total/retenciones
  // para una fila, dado el insumo ya elegido (fila.insumoCompleto). No muta `fila`,
  // regresa un objeto nuevo (o la misma referencia si no hay insumo, para no romper
  // la identidad de filas vacías). Extraído de onChangePrecioCantidadDescuento para
  // poder recalcular varias filas de un jalón (ver onChangeProveedor).
  calcularCamposFila(fila, proveedorId) {
    const insumo = fila?.insumoCompleto;
    if (!insumo) return fila;

    const nuevaFila = { ...fila };
    const precioUnitario = Number(nuevaFila.precioUnitario);

    let totalImpuestosPrecioSinImpuestos = 0;
    if (!this.state.proveedorExtranjero) {
      insumo.impuestos.map((valueImpuesto) => {
        let totalImpuesto;
        if (valueImpuesto.tasaCuota === 1) {
          totalImpuesto = precioUnitario * (valueImpuesto.monto / 100);
        } else if (valueImpuesto.tasaCuota === 2) {
          totalImpuesto =
            (precioUnitario + totalImpuestosPrecioSinImpuestos) *
            (valueImpuesto.monto / 100);
        } else if (valueImpuesto.tasaCuota === 3) {
          totalImpuesto = valueImpuesto.monto;
        } else if (valueImpuesto.tasaCuota === 4) {
          let cantidad = nuevaFila.cantidad;
          if (cantidad) {
            totalImpuesto = (nuevaFila.impuestos || 0) / nuevaFila.cantidad;
          }
        } else if (valueImpuesto.tasaCuota === 5) {
          totalImpuesto = 0;
        }
        totalImpuestosPrecioSinImpuestos += totalImpuesto;
        return null;
      });
    }
    nuevaFila.precioUnitarioConImpuestos = round2Decimals(
      precioUnitario + totalImpuestosPrecioSinImpuestos
    );
    const cantidad = nuevaFila.cantidad;
    const descuento = nuevaFila.descuento || 0;

    if ((precioUnitario || precioUnitario === 0) && cantidad && insumo) {
      const subtotal = round6Decimals(cantidad * precioUnitario);
      const totalDescuento = round6Decimals(subtotal * (descuento / 100));
      const totalEntrada = round6Decimals(subtotal - totalDescuento);
      nuevaFila.subtotal = totalEntrada;

      let totalImpuestos = 0;
      let arrayImpuestos = [];
      if (!this.state.proveedorExtranjero) {
        arrayImpuestos = insumo.impuestos.map((valueImpuesto) => {
          let totalImpuesto;
          if (valueImpuesto.tasaCuota === 1) {
            totalImpuesto = round6Decimals(
              totalEntrada * (valueImpuesto.monto / 100)
            );
          } else if (valueImpuesto.tasaCuota === 2) {
            totalImpuesto = round6Decimals(
              (totalEntrada + totalImpuestos) * (valueImpuesto.monto / 100)
            );
          } else if (valueImpuesto.tasaCuota === 3) {
            totalImpuesto = round6Decimals(cantidad * valueImpuesto.monto);
          } else if (valueImpuesto.tasaCuota === 4) {
            totalImpuesto = round6Decimals(nuevaFila.impuestos);
          } else if (valueImpuesto.tasaCuota === 5) {
            totalImpuesto = 0;
          }
          totalImpuestos += totalImpuesto;
          return {
            descripcionFactura: valueImpuesto.descripcionFactura,
            totalImpuestos: totalImpuesto,
          };
        });
      }
      nuevaFila.impuestos = totalImpuestos;
      nuevaFila.arrayImpuestos = arrayImpuestos;
      const total = round2Decimals(nuevaFila.subtotal + totalImpuestos);
      nuevaFila.total = total;

      if (proveedorId) {
        const proveedor = this.state.todasProveedores.find(
          (valueP) => valueP._id === proveedorId
        );
        let totalRetenciones = 0;
        let arrayRetenciones = [];

        proveedor.retenciones.map((valueRetencion) => {
          let totalRetencion;
          if (valueRetencion.tasaCuota === 1) {
            totalRetencion = round6Decimals(
              totalEntrada * (valueRetencion.monto / 100)
            );
          } else if (valueRetencion.tasaCuota === 2) {
            totalRetencion = round6Decimals(
              (totalEntrada + totalRetenciones) * (valueRetencion.monto / 100)
            );
          }
          totalRetenciones += totalRetencion;
          arrayRetenciones.push({
            descripcionFactura: valueRetencion.descripcionFactura,
            totalRetenciones: totalRetencion,
          });
          return null;
        });

        if (!this.state.proveedorExtranjero) {
          insumo.retenciones.map((valueRetencion) => {
            if (
              (valueRetencion.aplicaCompra === 1 &&
                proveedor.persona === false) ||
              (valueRetencion.aplicaCompra === 2 &&
                proveedor.persona === true) ||
              valueRetencion.aplicaCompra === 3
            ) {
              let totalRetencion;
              if (valueRetencion.tasaCuota === 1) {
                totalRetencion = round6Decimals(
                  totalEntrada * (valueRetencion.monto / 100)
                );
              } else if (valueRetencion.tasaCuota === 2) {
                totalRetencion = round6Decimals(
                  (totalEntrada + totalRetenciones) *
                    (valueRetencion.monto / 100)
                );
              }
              totalRetenciones += totalRetencion;
              arrayRetenciones.push({
                descripcionFactura: valueRetencion.descripcionFactura,
                totalRetenciones: totalRetencion,
              });
            }
            return null;
          });
        }
        nuevaFila.retenciones = totalRetenciones;
        nuevaFila.arrayRetenciones = arrayRetenciones;
      }
    }

    return nuevaFila;
  }

  async onChangeInsumo(value, key, insumoSeleccionado) {
    let arrayValue = await this.formRef.current.getFieldValue("insumos");
    let proveedorId = await this.formRef.current.getFieldValue("proveedorId");
    
    const insumo = insumoSeleccionado; 

    if (!insumo) return;

    arrayValue[key].insumoCompleto = insumo; 

    const precioAnterior = arrayValue.find(
      (item, idx) => idx !== key && String(item?.insumoId) === String(value) && item?.precioUnitario
    )?.precioUnitario;
    arrayValue[key].precioUnitario = precioAnterior || insumo.costo || 0;

    // Complemento Escuela: el renglon trae el descuento predeterminado del
    // proveedor. Con descuento se precarga el costo bruto: el de la relacion ya
    // quedo neto del descuento de la ultima compra y se descontaria dos veces.
    if (this.props.escuela) {
      const descuentoProveedor = this.descuentoPredeterminadoProveedor();
      aplicarDescuentoBaseAFila(arrayValue[key], descuentoProveedor);
      if (descuentoProveedor > 0 && !precioAnterior) {
        arrayValue[key].precioUnitario = costoParaDescuentoProveedor(insumo);
      }
    }

    const precioUnitario = Number(arrayValue[key].precioUnitario);

    let totalImpuestosPrecioSinImpuestos = 0;
    if (!this.state.proveedorExtranjero) {
      insumo.impuestos.map((valueImpuesto) => {
        let totalImpuesto;
        if (valueImpuesto.tasaCuota === 1) {
          totalImpuesto = precioUnitario * (valueImpuesto.monto / 100);
        } else if (valueImpuesto.tasaCuota === 2) {
          totalImpuesto =
            (precioUnitario + totalImpuestosPrecioSinImpuestos) *
            (valueImpuesto.monto / 100);
        } else if (valueImpuesto.tasaCuota === 3) {
          totalImpuesto = valueImpuesto.monto;
        } else if (valueImpuesto.tasaCuota === 4) {
          let cantidad = arrayValue[key].cantidad;
          if (cantidad) {
            totalImpuesto =
              (arrayValue[key].impuestos || 0) / arrayValue[key].cantidad;
          }
        } else if (valueImpuesto.tasaCuota === 5) {
          totalImpuesto = 0;
        }
        totalImpuestosPrecioSinImpuestos += totalImpuesto;
        return null;
      });
    }
    arrayValue[key].precioUnitarioConImpuestos = round2Decimals(
      precioUnitario + totalImpuestosPrecioSinImpuestos
    );

    const cantidad = arrayValue[key].cantidad;
    const descuento = arrayValue[key].descuento || 0;

    if ((precioUnitario || precioUnitario === 0) && cantidad && insumo) {
      //1
      const subtotal = round6Decimals(cantidad * precioUnitario);
      //2
      const totalDescuento = round6Decimals(subtotal * (descuento / 100));
      //3
      const totalEntrada = round6Decimals(subtotal - totalDescuento);
      arrayValue[key].subtotal = totalEntrada;

      let totalImpuestos = 0;
      let arrayImpuestos;
      if (!this.state.proveedorExtranjero) {
        arrayImpuestos = insumo.impuestos.map(
          //4
          (valueImpuesto) => {
            let totalImpuesto;
            if (valueImpuesto.tasaCuota === 1) {
              totalImpuesto = round6Decimals(
                totalEntrada * (valueImpuesto.monto / 100)
              );
            } else if (valueImpuesto.tasaCuota === 2) {
              totalImpuesto = round6Decimals(
                (totalEntrada + totalImpuestos) * (valueImpuesto.monto / 100)
              );
            } else if (valueImpuesto.tasaCuota === 3) {
              totalImpuesto = round6Decimals(cantidad * valueImpuesto.monto);
            } else if (valueImpuesto.tasaCuota === 4) {
              totalImpuesto = round6Decimals(arrayValue[key].impuestos);
            } else if (valueImpuesto.tasaCuota === 5) {
              totalImpuesto = 0;
            }
            totalImpuestos += totalImpuesto;
            return {
              descripcionFactura: valueImpuesto.descripcionFactura,
              totalImpuestos: totalImpuesto,
            };
          }
        );
      }
      arrayValue[key].impuestos = totalImpuestos;
      arrayValue[key].arrayImpuestos = arrayImpuestos;
      //5
      const total = round2Decimals(arrayValue[key].subtotal + totalImpuestos);
      arrayValue[key].total = total;

      if (proveedorId) {
        //Consultar proveedor

        const proveedor = this.state.todasProveedores.find(
          (valueP) => valueP._id === proveedorId
        );
        //6
        let totalRetenciones = 0;
        let arrayRetenciones = [];

        proveedor.retenciones.map((valueRetencion) => {
          //7
          let totalRetencion;
          if (valueRetencion.tasaCuota === 1) {
            totalRetencion = round6Decimals(
              totalEntrada * (valueRetencion.monto / 100)
            );
          } else if (valueRetencion.tasaCuota === 2) {
            totalRetencion = round6Decimals(
              (totalEntrada + totalRetenciones) * (valueRetencion.monto / 100)
            );
          }
          totalRetenciones += totalRetencion;
          arrayRetenciones.push({
            descripcionFactura: valueRetencion.descripcionFactura,
            totalRetenciones: totalRetencion,
          });
          return null;
        });

        if (!this.state.proveedorExtranjero) {
          insumo.retenciones.map((valueRetencion) => {
            if (
              (valueRetencion.aplicaCompra === 1 &&
                proveedor.persona === false) ||
              (valueRetencion.aplicaCompra === 2 &&
                proveedor.persona === true) ||
              valueRetencion.aplicaCompra === 3
            ) {
              //7
              let totalRetencion;
              if (valueRetencion.tasaCuota === 1) {
                totalRetencion = round6Decimals(
                  totalEntrada * (valueRetencion.monto / 100)
                );
              } else if (valueRetencion.tasaCuota === 2) {
                totalRetencion = round6Decimals(
                  (totalEntrada + totalRetenciones) *
                    (valueRetencion.monto / 100)
                );
              }
              totalRetenciones += totalRetencion;
              arrayRetenciones.push({
                descripcionFactura: valueRetencion.descripcionFactura,
                totalRetenciones: totalRetencion,
              });
            }
            return null;
          });
        }
        arrayValue[key].retenciones = totalRetenciones;
        arrayValue[key].arrayRetenciones = arrayRetenciones;
      }
    }

    const aplicarValoresInsumo = () => {
      this.aplicarFila(key, arrayValue);
    };

    const monedaOrden = this.formRef.current.getFieldValue("monedaId");
    const monedaInsumo = insumo.monedaId;

    if (monedaInsumo && monedaOrden && String(monedaInsumo) !== String(monedaOrden)) {
      const nombreMoneda = (id) => {
        const moneda = this.state.todasMonedas?.find((valueM) => String(valueM._id) === String(id));
        return moneda ? (moneda.abreviacion || moneda.nombre) : "otra moneda";
      };
      Modal.confirm({
        title: "Moneda distinta a la de la orden",
        content: `Este insumo tiene configurada la moneda ${nombreMoneda(monedaInsumo)} en su relación con este proveedor, pero la orden está en ${nombreMoneda(monedaOrden)}. ¿Deseas agregarlo así de todas formas?`,
        okText: "Agregar de todas formas",
        cancelText: "Cancelar",
        onOk: aplicarValoresInsumo,
        onCancel: () => {
          arrayValue[key].insumoId = undefined;
          arrayValue[key].insumoCompleto = null;
          this.aplicarFila(key, arrayValue);
        },
      });
    } else {
      aplicarValoresInsumo();
    }
  }


  async onChangePrecioCantidadDescuento(value, key) {
    const arrayValue = this.formRef.current.getFieldValue("insumos");
    const proveedorId = this.formRef.current.getFieldValue("proveedorId");

    if (!arrayValue[key]?.insumoCompleto) return;

    const nuevaFila = this.calcularCamposFila(arrayValue[key], proveedorId);
    const nuevoArray = arrayValue.slice();
    nuevoArray[key] = nuevaFila;
    this.formRef.current.setFields([{ name: "insumos", value: nuevoArray }]);
  }

  // Complemento Escuela: % predeterminado del proveedor seleccionado.
  descuentoPredeterminadoProveedor = () => {
    const proveedorId = this.formRef.current?.getFieldValue("proveedorId");
    const proveedor = this.state.todasProveedores.find((valueP) => valueP._id === proveedorId);
    return proveedor?.descuentoPredeterminado || 0;
  };

  // Complemento Escuela: Desc. Prov. y Desc. Adic. alimentan `descuento` (su
  // cascada), que es el unico que entra en el calculo.
  onChangeDescuentoEscuela(key) {
    const arrayValue = this.formRef.current.getFieldValue("insumos");
    if (!arrayValue[key]) return;
    const nuevoArray = arrayValue.slice();
    nuevoArray[key] = sincronizarDescuentoFila({ ...arrayValue[key] });
    this.formRef.current.setFields([{ name: "insumos", value: nuevoArray }]);
    this.onChangePrecioCantidadDescuento(undefined, key);
  }

  async onChangePrecioImpuestos(value, key) {
    const arrayValue = this.formRef.current.getFieldValue("insumos");
    const proveedorId = this.formRef.current.getFieldValue("proveedorId");

    const insumo = arrayValue[key]?.insumoCompleto;
    if (!insumo) return;

    const precioUnitarioConImpuestos =
      arrayValue[key].precioUnitarioConImpuestos;

    let totalPorcentajeImpuestos = 1;
    let totalCantidadImpuestos = 0;
    if (!this.state.proveedorExtranjero) {
      insumo.impuestos.map((valueImpuesto) => {
        if (valueImpuesto.tasaCuota === 1) {
          totalPorcentajeImpuestos += valueImpuesto.monto / 100;
        } else if (valueImpuesto.tasaCuota === 2) {
          totalPorcentajeImpuestos +=
            totalPorcentajeImpuestos * (valueImpuesto.monto / 100);
        } else if (valueImpuesto.tasaCuota === 3) {
          totalCantidadImpuestos = valueImpuesto.monto;
        }
        return null;
      });
    }

    const precioUnitario =
      precioUnitarioConImpuestos / totalPorcentajeImpuestos +
      totalCantidadImpuestos;
    arrayValue[key].precioUnitario = precioUnitario;
    const cantidad = arrayValue[key].cantidad;
    const descuento = arrayValue[key].descuento || 0;

    if ((precioUnitario || precioUnitario === 0) && cantidad && insumo) {
      //1
      const subtotal = round6Decimals(cantidad * precioUnitario);
      //2
      const totalDescuento = round6Decimals(subtotal * (descuento / 100));
      //3
      const totalEntrada = round6Decimals(subtotal - totalDescuento);
      arrayValue[key].subtotal = totalEntrada;

      let totalImpuestos = 0;
      let arrayImpuestos = [];
      if (!this.state.proveedorExtranjero) {
        arrayImpuestos = insumo.impuestos.map(
          //4
          (valueImpuesto) => {
            let totalImpuesto;
            if (valueImpuesto.tasaCuota === 1) {
              totalImpuesto = round6Decimals(
                totalEntrada * (valueImpuesto.monto / 100)
              );
            } else if (valueImpuesto.tasaCuota === 2) {
              totalImpuesto = round6Decimals(
                (totalEntrada + totalImpuestos) * (valueImpuesto.monto / 100)
              );
            } else if (valueImpuesto.tasaCuota === 3) {
              totalImpuesto = round6Decimals(cantidad * valueImpuesto.monto);
            } else if (valueImpuesto.tasaCuota === 4) {
              totalImpuesto = round6Decimals(arrayValue[key].impuestos);
            } else if (valueImpuesto.tasaCuota === 5) {
              totalImpuesto = 0;
            }
            totalImpuestos += totalImpuesto;
            return {
              descripcionFactura: valueImpuesto.descripcionFactura,
              totalImpuestos: totalImpuesto,
            };
          }
        );
      }
      arrayValue[key].impuestos = totalImpuestos;
      arrayValue[key].arrayImpuestos = arrayImpuestos;
      //5
      const total = round2Decimals(arrayValue[key].subtotal + totalImpuestos);
      arrayValue[key].total = total;

      if (proveedorId) {
        //Consultar proveedor

        const proveedor = this.state.todasProveedores.find(
          (valueP) => valueP._id === proveedorId
        );
        //6
        let totalRetenciones = 0;
        let arrayRetenciones = [];

        proveedor.retenciones.map((valueRetencion) => {
          //7
          let totalRetencion;
          if (valueRetencion.tasaCuota === 1) {
            totalRetencion = round6Decimals(
              totalEntrada * (valueRetencion.monto / 100)
            );
          } else if (valueRetencion.tasaCuota === 2) {
            totalRetencion = round6Decimals(
              (totalEntrada + totalRetenciones) * (valueRetencion.monto / 100)
            );
          }
          totalRetenciones += totalRetencion;
          arrayRetenciones.push({
            descripcionFactura: valueRetencion.descripcionFactura,
            totalRetenciones: totalRetencion,
          });
          return null;
        });

        if (!this.state.proveedorExtranjero) {
          insumo.retenciones.map((valueRetencion) => {
            if (
              (valueRetencion.aplicaCompra === 1 &&
                proveedor.persona === false) ||
              (valueRetencion.aplicaCompra === 2 && proveedor.persona === true) ||
              valueRetencion.aplicaCompra === 3
            ) {
              //7
              let totalRetencion;
              if (valueRetencion.tasaCuota === 1) {
                totalRetencion = round6Decimals(
                  totalEntrada * (valueRetencion.monto / 100)
                );
              } else if (valueRetencion.tasaCuota === 2) {
                totalRetencion = round6Decimals(
                  (totalEntrada + totalRetenciones) * (valueRetencion.monto / 100)
                );
              }
              totalRetenciones += totalRetencion;
              arrayRetenciones.push({
                descripcionFactura: valueRetencion.descripcionFactura,
                totalRetenciones: totalRetencion,
              });
            }
            return null;
          });
        }
        arrayValue[key].retenciones = totalRetenciones;
        arrayValue[key].arrayRetenciones = arrayRetenciones;
      }
    }
    this.aplicarFila(key, arrayValue);
  }

  aplicarMoneda(value) {
    if (value === "60c7e4396465ad440c41c15a") {
      this.formRef.current.setFieldsValue({ monedaId: value, tipoDeCambio: 1 });
    } else {
      this.formRef.current.setFieldsValue({ monedaId: value });
      this.onChangeMoneda(value);
    }
  }

  onChangeMoneda(value) {
    if (value && value !== "60c7e4396465ad440c41c15a") {
      axios
        .post(
          "tipoDeCambio/obtenerTipoDeCambio",
          {
            monedaId: value,
            empresaId: this.props.empresaId,
          },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          if (res.data.success === 2) {
            if (res.data.monedaString && res.data.dia) {
              message.success(
                "Se ha obtenido el tipo de cambio" +
                  (res.data.monedaString ? " " + res.data.monedaString : "") +
                  (res.data.dia ? " del día " + res.data.dia : "")
              );
            }
            this.formRef.current.setFieldsValue({
              tipoDeCambio: res.data.tipoDeCambio,
            });
          }
        });
    }
  }

  async onChangeProveedor(value, _, dejarInsumos) {
    const proveedor = this.state.todasProveedores.find(
      (valueProv) => valueProv._id === value
    );
    if (!proveedor.tipoProveedorId) {
      const nombre = proveedor.persona
        ? proveedor.razonSocial
        : `${proveedor.nombre} ${proveedor.apellidoPaterno} ${proveedor.apellidoMaterno}`;
      this.abrirElegirTipoDeProveedor(proveedor._id, nombre);
    }
    this.setState({ proveedorSeleccionado: proveedor });
    let arrayValue = await this.formRef.current.getFieldValue("insumos");
    const fechaFactura = this.formRef.current.getFieldValue("fechaFactura");
    this.formRef.current.setFieldsValue({
      insumos: dejarInsumos ? arrayValue : [],
      fechaPago: moment(fechaFactura).add(proveedor.diasCredito, "days"),
      diasCredito: proveedor.diasCredito || 0,
      usoDeCfdiId: proveedor.usoDeCfdiId || undefined,
      metodoPago: proveedor.metodoPago || undefined,
      formaDePagoId: proveedor.formaDePagoId || undefined,
    });
    if (proveedor.monedaId) {
      this.aplicarMoneda(proveedor.monedaId);
    }

    if (arrayValue?.length > 0 && dejarInsumos) {
      const nuevoArray = arrayValue.map((fila) => this.calcularCamposFila(fila, value));
      this.formRef.current.setFields([{ name: "insumos", value: nuevoArray }]);
    }

    this.setState({
      loading: false,
      proveedorExtranjero: proveedor.proveedorExtranjero || false,
      proveedorId: value,
    });
  }
 
  abrirElegirTipoDeProveedor(id, nombre) {
    this.setState({
      modalElegirTipoDeProveedor: true,
      modalElegirTipoDeProveedorId: id,
      modalElegirTipoDeProveedorNombre: nombre,
    });
  }
  cerrarElegirTipoDeProveedor(elegido) {
    if (!elegido) {
      this.formRef.current.setFieldsValue({ proveedorId: undefined });
    }
    this.consultarTodo();
    this.setState({
      modalElegirTipoDeProveedor: false,
      modalElegirTipoDeProveedorId: null,
      modalElegirTipoDeProveedorNombre: null,
    });
  }
  abrirObservaciones(index, observaciones, observacionesPasadas) {
    const proveedorIdActual = this.formRef.current.getFieldValue('proveedorId');
    const proveedorActual = this.state.todasProveedores.find(p => p._id === proveedorIdActual);
    const nombreProveedorActual = proveedorActual ? (proveedorActual.persona ? proveedorActual.razonSocial : `${proveedorActual.nombre} ${proveedorActual.apellidoPaterno} ${proveedorActual.apellidoMaterno}`) : 'Proveedor Desconocido';
    this.setState({
      modalObservaciones: true,
      modalObservacionesIndex: index,
      modalObservacionesObservaciones: observaciones,
      modalObservacionesObservacionesPasadas: observacionesPasadas,
      proveedorIdActual: proveedorIdActual, 
      nombreProveedorActual: nombreProveedorActual
    });
  }
  cerrarObservaciones(value) {
    const insumos = this.formRef.current.getFieldValue("insumos");
    insumos[this.state.modalObservacionesIndex].observaciones = value;
    this.formRef.current.setFieldsValue({
      insumos: insumos,
    });
    this.setState({
      modalObservaciones: false,
      modalObservacionesIndex: null,
      modalObservacionesObservaciones: null,
      modalObservacionesObservacionesPasadas: null,
      proveedorIdActual: null,
      nombreProveedorActual: null
    });
  }
  abrirModalAsignarInsumo = () => {
    this.setState({ modalAsignarInsumoVisible: true });
  };
  /*
  cerrarModalAsignarInsumo = (nuevoInsumoRelacionado) => {
    if (nuevoInsumoRelacionado) {
    }
    this.setState({ modalAsignarInsumoVisible: false, loading: false });
  };*/

  cerrarModalAsignarInsumo = async (nuevoInsumoRelacionado) => {
    this.setState({modalAsignarInsumoVisible: false, loading: false}); 

    if(nuevoInsumoRelacionado && this.state.insumoIdRelacionando){
      const idRelacionado = this.state.insumoIdRelacionando;
      const dataEcommerce = this.state.insumoDataRelacionando;
      const proveedorId = this.formRef.current.getFieldValue("proveedorId");

      const insumosSinRelacion = this.state.insumosSinRelacion.filter(
         i => String(i.insumoId) !== String(idRelacionado)
      );
      
      let currentInsumos = this.formRef.current.getFieldValue("insumos") || [];
      const nuevoIndex = currentInsumos.length;
      
      currentInsumos.push({
        ...dataEcommerce,
        insumoCompleto: null, 
      });
      this.formRef.current.setFieldsValue({ insumos: currentInsumos });

      await this.recargarInsumoEditado(proveedorId, idRelacionado, nuevoIndex);

      this.setState({ 
        insumosSinRelacion: insumosSinRelacion,
        insumoIdRelacionando: null,
        insumoDataRelacionando: null
      });

      message.success("¡Insumo relacionado!");
      
      if(insumosSinRelacion.length === 0){
         this.setState({ modalSinRelacionVisible: false });
      }
    }
  }


  onChangeProyecto(value) {
    // const insumos = this.formRef.current.getFieldValue('insumos')

    const proyecto = this.state.todasProyectos?.find(
      (valueP) => valueP._id === value
    );
    if (
      proyecto &&
      Array.isArray(proyecto.subProyectos) &&
      proyecto?.subProyectos?.length > 0
    ) {
      this.setState({
        proyectosConSubproyectos: true,
        objetoSubproyectos: proyecto.subProyectos.map((value) => (
          <Option key={value._id} value={value._id}>
            {value.codigo + " - " +value.nombre}
          </Option>
        )),
       
      });
    }
    else{
      this.setState({
        proyectosConSubproyectos: false,
        objetoSubproyectos: []
      })
    }
    if(proyecto && proyecto.numeracionOrdenesSemana){
      this.setState({numeracionPorSemana: true,});
      this.formRef.current.setFieldsValue({
          numeroSemana: null
        });
    } else {
      this.setState({ numeracionPorSemana: false });
      this.formRef.current.setFieldsValue({ numeroSemana: null });
    }
    // if (Array.isArray(insumos) && insumos.length > 0) {
    //   const nuevosInsumos = insumos.map(insumo => {
    //     if (!insumo.proyectoId) {
    //       insumo.proyectoId = value
    //     }
    //     return insumo
    //   })
    //   this.formRef.current.setFieldsValue({
    //     insumos: nuevosInsumos
    //   })
    // }
  }

  calcularSemanaSugerida() {
    const ahora = moment();

    let semanasASumar = 1;
    const diaIso = ahora.isoWeekday();
    const hora = ahora.hour();

    if (diaIso > 4 || (diaIso === 4 && hora >= 18)) {
      
      semanasASumar = 2;
    }
    const fechaPlaneacion = ahora.clone().add(semanasASumar, "week");

    return fechaPlaneacion.isoWeek();
  }
  asignarSemanaAutomatica = () => {
    const semanaSugerida = this.calcularSemanaSugerida();
    this.formRef.current.setFieldsValue({
      numeroSemana: semanaSugerida,
    });
    message.success(`Semana ${semanaSugerida} calculada y asignada.`);
  };

  async recargarInsumoEditado(proveedorId, insumoId, arrayKey) {
    this.setState({ loading: true });
    try {
      const res = await axios.post(
        "insumos/selectInsumosRelacionesProveedor",
        {
          empresaId: this.props.empresaId,
          proveedorId: proveedorId,
          query: insumoId, 
          skip: 0
        },
        { headers: this.props.headersToken }
      );

      if (res.data.success === 2 && res.data.insumos && res.data.insumos.length > 0) {
        const insumoFresco = res.data.insumos[0];
        
        let arrayValue = this.formRef.current.getFieldValue("insumos");
        
        arrayValue[arrayKey].insumoCompleto = insumoFresco;
        arrayValue[arrayKey].insumoId = insumoFresco._id;
        arrayValue[arrayKey].precioUnitario = insumoFresco.costo || arrayValue[arrayKey].precioUnitario;
        
        this.formRef.current.setFieldsValue({ insumos: arrayValue });
        
        await this.onChangeInsumo(insumoFresco._id, arrayKey, insumoFresco);
      }
    } catch (error) {
      console.error("Error recargando el insumo modificado:", error);
    } finally {
      this.setState({ loading: false });
    }
  }

  cargarDatosDeEcommerce = async () => {
    const { location } = this.props;
    const datosPrecargados = location?.state?.datosPrecargados;

    if (datosPrecargados && datosPrecargados.vieneDeEcommerce) {
      const { proyectoId, proveedorId,  insumos, ventaSerie } = datosPrecargados;
      if (proyectoId) {
        this.formRef.current.setFieldsValue({ proyectoId });
        this.onChangeProyecto(proyectoId);
      }

      if (proveedorId) {
        this.formRef.current.setFieldsValue({ proveedorId });
        await this.onChangeProveedor(proveedorId, null, false); 
      }

      if (insumos && insumos.length > 0) {
        this.formRef.current.setFieldsValue({
          observaciones2: `Orden de Dropshipping generada desde Venta Online: Folio ${ventaSerie}`,
        });

        let validos = [];
        let sinRelacion = [];

        for (let i = 0; i < insumos.length; i++) {
          const itemEcommerce = insumos[i];
          
          try {
            const res = await axios.post(
              "insumos/selectInsumosRelacionesProveedor",
              {
                empresaId: this.props.empresaId,
                proveedorId: proveedorId,
                query: itemEcommerce.insumoId, 
                skip: 0
              },
              { headers: this.props.headersToken }
            );

            if (res.data.success === 2 && res.data.insumos && res.data.insumos.length > 0) {
              const insumoFresco = res.data.insumos[0];
              validos.push({
                 ...itemEcommerce,
                 insumoId: insumoFresco._id,
                 insumoCompleto: insumoFresco,
                 precioUnitario: insumoFresco.costo || itemEcommerce.precioUnitario || 0,
                 descuento: 0
              });
            } else {

              sinRelacion.push(itemEcommerce);
            }
          } catch (err) {
             sinRelacion.push(itemEcommerce);
          }
        }

        if (validos.length > 0) {
          /*
          for (let i = 0; i < validos.length; i++) {
            await this.onChangePrecioCantidadDescuento(validos[i].precioUnitario, i);
          }*/
        }

        if (sinRelacion.length > 0) {
          this.setState({ 
            insumosSinRelacion: sinRelacion, 
            modalSinRelacionVisible: true 
          });
          message.warning(`Hay ${sinRelacion.length} insumo(s) que no están relacionados con el proveedor.`);
        } else {
          message.success("Todos los insumos se cargaron y relacionaron exitosamente.");
        }
        this.formRef.current.setFieldsValue({ insumos: validos });
        for (let i = 0; i < validos.length; i++) {
          await this.onChangeInsumo(validos[i].insumoId, i, validos[i].insumoCompleto);
        }
      }
    }
  };

  // Réplica pura (sin tocar el form) de los cálculos de onChangeInsumo/onChangePrecioCantidadDescuento.
  // Se usa en la carga masiva por Excel para no disparar un re-render del formulario por cada fila.
  calcularTotalesInsumoOC({ insumo, precioUnitario, cantidad, descuento, proveedor }) {
    const proveedorExtranjero = this.state.proveedorExtranjero;
    precioUnitario = Number(precioUnitario);

    let totalImpuestosPrecioSinImpuestos = 0;
    if (!proveedorExtranjero) {
      insumo.impuestos.forEach((valueImpuesto) => {
        let totalImpuesto = 0;
        if (valueImpuesto.tasaCuota === 1) {
          totalImpuesto = precioUnitario * (valueImpuesto.monto / 100);
        } else if (valueImpuesto.tasaCuota === 2) {
          totalImpuesto = (precioUnitario + totalImpuestosPrecioSinImpuestos) * (valueImpuesto.monto / 100);
        } else if (valueImpuesto.tasaCuota === 3) {
          totalImpuesto = valueImpuesto.monto;
        } else if (valueImpuesto.tasaCuota === 5) {
          totalImpuesto = 0;
        }
        totalImpuestosPrecioSinImpuestos += totalImpuesto;
      });
    }
    const precioUnitarioConImpuestos = round2Decimals(precioUnitario + totalImpuestosPrecioSinImpuestos);

    let subtotal = 0, impuestos = 0, arrayImpuestos = [], total = 0, retenciones = 0, arrayRetenciones = [];

    if ((precioUnitario || precioUnitario === 0) && cantidad) {
      const subtotalBruto = round6Decimals(cantidad * precioUnitario);
      const totalDescuento = round6Decimals(subtotalBruto * (descuento / 100));
      const totalEntrada = round6Decimals(subtotalBruto - totalDescuento);
      subtotal = totalEntrada;

      let totalImpuestos = 0;
      if (!proveedorExtranjero) {
        arrayImpuestos = insumo.impuestos.map((valueImpuesto) => {
          let totalImpuesto = 0;
          if (valueImpuesto.tasaCuota === 1) {
            totalImpuesto = round6Decimals(totalEntrada * (valueImpuesto.monto / 100));
          } else if (valueImpuesto.tasaCuota === 2) {
            totalImpuesto = round6Decimals((totalEntrada + totalImpuestos) * (valueImpuesto.monto / 100));
          } else if (valueImpuesto.tasaCuota === 3) {
            totalImpuesto = round6Decimals(cantidad * valueImpuesto.monto);
          } else if (valueImpuesto.tasaCuota === 5) {
            totalImpuesto = 0;
          }
          totalImpuestos += totalImpuesto;
          return { descripcionFactura: valueImpuesto.descripcionFactura, totalImpuestos: totalImpuesto };
        });
      }
      impuestos = totalImpuestos;
      total = round2Decimals(subtotal + totalImpuestos);

      if (proveedor) {
        let totalRetenciones = 0;
        proveedor.retenciones.forEach((valueRetencion) => {
          let totalRetencion = 0;
          if (valueRetencion.tasaCuota === 1) {
            totalRetencion = round6Decimals(totalEntrada * (valueRetencion.monto / 100));
          } else if (valueRetencion.tasaCuota === 2) {
            totalRetencion = round6Decimals((totalEntrada + totalRetenciones) * (valueRetencion.monto / 100));
          }
          totalRetenciones += totalRetencion;
          arrayRetenciones.push({ descripcionFactura: valueRetencion.descripcionFactura, totalRetenciones: totalRetencion });
        });

        if (!proveedorExtranjero) {
          insumo.retenciones.forEach((valueRetencion) => {
            if (
              (valueRetencion.aplicaCompra === 1 && proveedor.persona === false) ||
              (valueRetencion.aplicaCompra === 2 && proveedor.persona === true) ||
              valueRetencion.aplicaCompra === 3
            ) {
              let totalRetencion = 0;
              if (valueRetencion.tasaCuota === 1) {
                totalRetencion = round6Decimals(totalEntrada * (valueRetencion.monto / 100));
              } else if (valueRetencion.tasaCuota === 2) {
                totalRetencion = round6Decimals((totalEntrada + totalRetenciones) * (valueRetencion.monto / 100));
              }
              totalRetenciones += totalRetencion;
              arrayRetenciones.push({ descripcionFactura: valueRetencion.descripcionFactura, totalRetenciones: totalRetencion });
            }
          });
        }
        retenciones = totalRetenciones;
      }
    }

    return { precioUnitarioConImpuestos, subtotal, impuestos, arrayImpuestos, total, retenciones, arrayRetenciones };
  }

  cargarInsumosDesdeExcel = (filasValidas) => {
    const proveedorId = this.formRef.current.getFieldValue("proveedorId");
    const proveedor = this.state.todasProveedores.find((p) => p._id === proveedorId);

    const filasFinal = filasValidas.map((f) => {
      const cantidad = f.cantidad;
      const descuento = f.descuento || 0;
      const totales = this.calcularTotalesInsumoOC({
        insumo: f.insumoCompleto,
        precioUnitario: f.precioUnitario,
        cantidad,
        descuento,
        proveedor,
      });
      const fila = {
        insumoId: f.insumoId,
        insumoCompleto: f.insumoCompleto,
        cantidad,
        precioUnitario: f.precioUnitario,
        descuento,
        observaciones: f.observaciones,
        ...totales,
      };
      // Complemento Escuela: el descuento del Excel se muestra como adicional.
      return this.props.escuela ? normalizarDescuentoFila(fila) : fila;
    });

    this.formRef.current.setFieldsValue({ insumos: filasFinal });
    this.setState({ modalCargarExcelVisible: false });
    message.success(`${filasFinal.length} línea(s) cargada(s) desde Excel.`);
  };

  buscarInsumo = (valor) => {
    this.setState({ busquedaInsumo: valor, insumoResaltado: null });
    if (!valor) return;

    const insumos = this.formRef.current?.getFieldValue("insumos") || [];
    const texto = valor.toLowerCase();
    const index = insumos.findIndex((insumo) => {
      const infoInsumo = insumo.insumoCompleto;
      if (!infoInsumo) return false;
      return (
        infoInsumo.descripcion?.toLowerCase().includes(texto) ||
        infoInsumo.codigo?.toLowerCase().includes(texto) ||
        infoInsumo.clave?.toLowerCase().includes(texto) ||
        infoInsumo.codigoBarras?.toLowerCase().includes(texto)
      );
    });

    if (index === -1) {
      message.warning("No se encontró ningún insumo con ese criterio");
      return;
    }

    this.setState({ insumoResaltado: index });

    const fila = document.getElementById(`insumo-row-${index}`);
    if (fila) {
      fila.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  renderProyectoCard() {
    return (
      <FormItem
        noStyle
        shouldUpdate={(prev, curr) =>
          prev.proyectoId !== curr.proyectoId || prev.proveedorId !== curr.proveedorId
        }
      >
        {({ getFieldValue }) => {
          const proyectoId = getFieldValue("proyectoId");
          const proveedorId = getFieldValue("proveedorId");
          if (!proyectoId) return null;
          const proyecto = this.state.todasProyectos?.find((value) => value._id === proyectoId);
          const proveedor = proveedorId ? this.state.todasProveedores?.find((value) => value._id === proveedorId) : null;
          if (!proyecto) return null;

          return (
            <Row gutter={[16, 16]}>
              <InfoCard
                title="PROYECTO"
                icon={<InfoCircleOutlined />}
                accentColor="#00BFD6"
                compact
                lg={12}
                sections={[
                  {
                    title: "Información General",
                    icon: <InfoCircleOutlined />,
                    iconColor: "#00BFD6",
                    lg: 12,
                    items: [
                      { label: "Nombre", value: proyecto.nombre || "-" },
                      { label: "Descripción", value: proyecto.descripcion || "-" },
                    ],
                  },
                  {
                    title: proyecto.calle ? "Dirección de envío" : "Vehículo",
                    icon: proyecto.calle ? <EnvironmentOutlined /> : <CarOutlined />,
                    iconColor: "#C9DF00",
                    lg: 12,
                    items: proyecto.calle ? [
                      { label: "Calle", value: proyecto.calle },
                      { label: "Número", value: proyecto.numeroCalle || "-" },
                    ] : [
                      { label: "Marca", value: proyecto.marca || "-" },
                      { label: "Modelo", value: proyecto.modelo || "-" },
                      { label: "Placas", value: proyecto.placas || "-" },
                    ],
                  },
                ]}
              />
              <InfoCard
                title="PROVEEDOR"
                icon={<UserOutlined />}
                accentColor="#00BFD6"
                compact
                lg={12}
                sections={
                  proveedor ? [
                    {
                      title: "Datos Generales",
                      icon: <UserOutlined />,
                      iconColor: "#FF6A0D",
                      lg: 13,
                      items: [
                        {
                          label: "Nombre",
                          value: proveedor.nombre
                            ? `${proveedor.nombre} ${proveedor.apellidoPaterno} ${proveedor.apellidoMaterno}`
                            : proveedor.razonSocial || "-",
                          bold: true,
                        },
                        { label: "RFC", value: proveedor.rfc },
                        { label: "Correo", value: proveedor.correo },
                        { label: "Teléfono", value: proveedor.telefono },
                        { label: "Celular", value: proveedor.celular },
                      ],
                    },
                    {
                      title: "Contacto",
                      icon: <PhoneFilled />,
                      iconColor: "#DB2777",
                      lg: 10,
                      items: [
                        { label: "Contacto",        value: proveedor.nombreContacto   || "-" },
                        { label: "Teléfono",        value: proveedor.telefonoContacto || "-" },
                        { label: "Correo",          value: proveedor.correoContacto   || "-" },
                        { label: "Días de crédito", value: proveedor.diasCredito       ?? "-" },
                      ],
                    },
                  ] : [
                    {
                      items: [{ label: null, value: "Sin proveedor seleccionado", color: "#aaa" }],
                    },
                  ]
                }
              />
            </Row>
          );
        }}
      </FormItem>
    );
  }

  getInsumosColumns() {
    return [
      { title: "#", width: "3%" },
      { title: "Clave",  width: "5%" },
      { title: "Insumo",  width: "21%" },
      { title: "Unidad", width: "5%" },
      { title: "Precio Unitario", width: "10%"  },
      { title: "Precio Unit. c/Imp.", width: "10%"  },
      { title: "Cant.",  width: "8%"  },
      { title: "F. Entrega", width: "8%" },
      ...(this.props.escuela ? [{ title: "Desc. Prov.", width: "7%" }] : []),
      { title: this.props.escuela ? "Desc. Adic." : "Descuento",  width: "8%"  },
      { title: "Subtotal / Imp. / Total", width: "12%" },
      { title: "Acción",  width: "10%"  },
    ];
  }

  // funcionesFila y renderInsumoRow: ver comentario de clase sobre por qué deben
  // tener identidad estable (no reconstruirse en cada render) — es lo que permite
  // que FilaInsumoOrdenDeCompra (React.memo) descarte el re-render de filas que
  // no cambiaron.
  funcionesFila = {
    onChangeInsumo: (value, key, insumo) => this.onChangeInsumo(value, key, insumo),
    onChangePrecioCantidadDescuento: (value, key) => this.onChangePrecioCantidadDescuento(value, key),
    onChangeDescuentoEscuela: (key) => this.onChangeDescuentoEscuela(key),
    onChangePrecioImpuestos: (value, key) => this.onChangePrecioImpuestos(value, key),
    abrirDisponibilidad: this.abrirDisponibilidad,
    abrirObservaciones: (...args) => this.abrirObservaciones(...args),
    recargarInsumoEditado: async (proveedorId, insumoId, arrayKey) => {
      const currentProveedorId = this.formRef.current.getFieldValue("proveedorId");
      await this.recargarInsumoEditado(currentProveedorId, insumoId, arrayKey);
    },
  };

  renderInsumoRow = ({ key, name, restField, arrayKey, remove }) => {
    const insumosValues = this.formRef.current?.getFieldValue("insumos") || [];
    const proyectoId = this.formRef.current?.getFieldValue("proyectoId");
    return (
      <FilaInsumoOrdenDeCompra
        key={key}
        name={name}
        restField={restField}
        arrayKey={arrayKey}
        remove={remove}
        insumosValues={insumosValues}
        modo="agregar"
        empresaId={this.props.empresaId}
        headersToken={this.props.headersToken}
        proveedorId={this.state.proveedorId}
        proyectoId={proyectoId}
        verInsumosComoSistema={this.state.verInsumosComoSistema}
        mostrarDetalles={this.state.mostrarDetalles}
        resaltado={this.state.insumoResaltado === arrayKey}
        totalColumnas={this.getInsumosColumns().length}
        escuela={this.props.escuela}
        funciones={this.funcionesFila}
      />
    );
  };

  // Config de agrupado que consume TabbedDynamicTable. `obtenerGrupo` lee el
  // arreglo del formulario en cada llamada (no lo captura) para que agrupar
  // refleje el insumo que la fila tiene AHORA, no el que tenía al renderizar.
  agrupacionPorFamilia = () => ({
    activa: this.state.agruparPorFamilia,
    obtenerGrupo: (arrayKey) =>
      grupoFamiliaDeFila((this.formRef.current?.getFieldValue("insumos") || [])[arrayKey]),
    renderEncabezado: (props) => <EncabezadoFamiliaOC {...props} listName="insumos" />,
  });

  getObservacionesConfig() {
    return {
      checkboxes: [
        {
          name: "imprimirObservaciones",
          label: "Imprimir Observaciones",
          initialValue: !!this.props.imprimirObservacionesOCPorDefecto,
        },
      ],
      totales: (
        <FormItem noStyle shouldUpdate={(prev, curr) => prev.insumos !== curr.insumos}>
          {({ getFieldValue }) => {
            const { subtotal, total, cuentasProveedor, arrayImpuestos, arrayRetenciones } =
              calcularTotalesOC(getFieldValue("insumos"));
            return (
              <table className="table" style={{ marginTop: 0, fontSize: "16px" }}>
                <tbody>
                  <tr>
                    <th className="th-totales" style={{ width: "50%", fontSize: "16px" }}>Subtotal</th>
                    <td className="td-totales-right" style={{ width: "50%", fontSize: "16px" }}>
                      {dineroDisabledMask(subtotal)}
                    </td>
                  </tr>
                </tbody>
                {arrayImpuestos.map((valueArray) => (
                  <tbody key={valueArray.descripcionFactura}>
                    <tr>
                      <th className="th-totales" style={{ fontSize: "16px" }}>{valueArray.descripcionFactura}</th>
                      <td className="td-totales-right" style={{ fontSize: "16px" }}>{dineroDisabledMask(valueArray.totalImpuestos)}</td>
                    </tr>
                  </tbody>
                ))}
                <tbody>
                  <tr>
                    <th className="th-totales" style={{ fontSize: "16px" }}>Total</th>
                    <td className="td-totales-right" style={{ fontSize: "16px" }}>
                      {dineroDisabledMask(total)}
                    </td>
                  </tr>
                </tbody>
                {arrayRetenciones.map((value, i) => (
                  <tbody key={i}>
                    <tr>
                      <th className="th-totales" style={{ fontSize: "16px" }}>{value.descripcionFactura}</th>
                      <td className="td-totales-right" style={{ fontSize: "16px" }}>{dineroDisabledMask(value.totalRetenciones)}</td>
                    </tr>
                  </tbody>
                ))}
                <tbody>
                  <tr>
                    <th className="th-totales" style={{ fontSize: "16px" }}>Total a pagar</th>
                    <td className="td-totales-right" style={{ fontSize: "16px" }}>
                      {dineroDisabledMask(total - cuentasProveedor)}
                    </td>
                  </tr>
                </tbody>
              </table>
            );
          }}
        </FormItem>
      ),
    };
  }

  render() {
    const isMobile = window.innerWidth <= 1000;
    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title="Agregar Orden de Compra"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
        />
        <div className="card-background">
          <Spin spinning={this.state.loading}>
            <Form
              ref={this.formRef}
              name="agregarOrdenDeCompra"
              layout
              onFinish={this.onFinish.bind(this)}
              onFinishFailed={this.onFinishFailed}
              onValuesChange={this.onValoresCambiaron}
            >
              <div style={{ padding: '0 16px', marginBottom: 0 }}>
                {this.renderProyectoCard()}
              </div>
              <GeneralFormLayout
                totalesMaxWidth="30%" 
                isMobile={isMobile}
                cards={[
                  {
                    title: "Datos Generales",
                    lg: 18,
                    content: (
                      <Row>
                        <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                          <FormItem label="Proyecto" name="proyectoId" margin required>
                            <SelectItem
                              placeholder="Proyecto"
                              onChange={(value) => this.onChangeProyecto(value)}
                            >
                              {this.state.objetoProyectos}
                            </SelectItem>
                          </FormItem>
                          {this.state.proyectosConSubproyectos && (
                            <FormItem noStyle shouldUpdate={(prev, curr) => prev.proyectoId !== curr.proyectoId}>
                              {({ getFieldValue }) => {
                                let proyectoId = getFieldValue("proyectoId");
                                if (!proyectoId) return null;
                                return (
                                  <FormItem label="Subproyecto" name="subProyectoId" margin>
                                    <SelectItem placeholder="Subproyecto" allowClear>
                                      {this.state.objetoSubproyectos}
                                    </SelectItem>
                                  </FormItem>
                                );
                              }}
                            </FormItem>
                          )}
                          <FormItem name="destino" label="Destino" max={50} margin pattern>
                            <InputItem placeholder="Domicilio, Ocurre.." />
                          </FormItem>
                          <FormItem name="embarque" label="Embarque" max={50} margin pattern>
                            <InputItem placeholder="Embarque" />
                          </FormItem>
                          <FormItem pattern name="atencion" label="Atención a" margin tooltip="Indica a quién dirigir este documento.">
                            <InputItem />
                          </FormItem>
                          <FormItem name="usoDeCfdiId" label="Uso de CFDI" margin>
                            <SelectItem placeholder="Uso de CFDI" allowClear>
                              {this.state.objetoUsosDeCFDI}
                            </SelectItem>
                          </FormItem>
                          <FormItem name="metodoPago" label="Método de Pago" margin>
                            <SelectItem
                              placeholder="Método de Pago"
                              allowClear
                              onChange={() => this.formRef.current.setFieldsValue({ formaDePagoId: undefined })}
                            >
                              <Option value={1}>PUE - Pago en Una sola Exhibición</Option>
                              <Option value={2}>PPD - Pago en Parcialidades o Diferido</Option>
                            </SelectItem>
                          </FormItem>
                          <FormItem noStyle shouldUpdate={(prev, curr) => prev.metodoPago !== curr.metodoPago}>
                            {({ getFieldValue }) => {
                              const metodoPago = getFieldValue("metodoPago");
                              const todas = this.state.todasFormasDePago || [];
                              let filtradas = todas;
                              if (metodoPago === 2) filtradas = todas.filter(v => v.c_FormaPago === 99);
                              else if (metodoPago === 1) filtradas = todas.filter(v => v.c_FormaPago !== 99);
                              return (
                                <FormItem name="formaDePagoId" label="Forma de Pago" margin>
                                  <SelectItem placeholder="Forma de Pago" allowClear>
                                    {filtradas.map(v => (
                                      <Option value={v._id} key={v._id}>
                                        {v.c_FormaPago + " - " + v.descripcion}
                                      </Option>
                                    ))}
                                  </SelectItem>
                                </FormItem>
                              );
                            }}
                          </FormItem>
                        </Col>
                        <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                          <FormItem label="Proveedor" name="proveedorId" margin required>
                            <SelectItem
                              placeholder="Proveedor"
                              onChange={this.onChangeProveedor.bind(this)}
                            >
                              {this.state.objetoProveedores}
                            </SelectItem>
                          </FormItem>
                          {this.state.proveedorId && (
                            <Row justify="center">
                              <Tooltip title="Asignar un nuevo insumo al proveedor seleccionado.">
                                <ButtonItem
                                  style={{ marginTop: 10, marginLeft: 15,marginBottom: 10, width: "auto" }}
                                  type="primary"
                                  onClick={this.abrirModalAsignarInsumo}
                                  block
                                  icon={<PlusOutlined />}
                                  cyan
                                  hotkey="alt+n"
                                >
                                  Asignar Nuevo Insumo
                                </ButtonItem>
                              </Tooltip>
                            </Row>
                          )}
                          <FormItem label="Fecha Entrega" name="fechaEntrega" margin>
                            <DatePickerItem placeholder="Fecha de Entrega" />
                          </FormItem>
                          <FormItem label="Cotización" name="cotizacionOC" margin>
                            <InputItem placeholder="Cotización" />
                          </FormItem>
                          {this.state.numeracionPorSemana && (
                            <Row gutter={8}>
                              <Col span={20}>
                                <FormItem
                                  label="N° semana"
                                  name="numeroSemana"
                                  margin
                                  tooltip="Número de la semana que aparecerá en el folio."
                                >
                                  <InputNumberItem placeholder="Semana" />
                                </FormItem>
                              </Col>
                              <Col span={4} style={{ display: "flex", alignItems: "center" }}>
                                <Tooltip title="Calcular la siguiente semana automáticamente">
                                  <ScheduleOutlined
                                    onClick={this.asignarSemanaAutomatica}
                                    style={{ fontSize: "22px", cursor: "pointer", color: "#1890ff" }}
                                  />
                                </Tooltip>
                              </Col>
                            </Row>
                          )}
                        </Col>
                      </Row>
                    ),
                  },
                  {
                    title: "Moneda",
                    lg: 6,
                    content: (
                      <>
                        <FormItem
                          required
                          margin
                          name="monedaId"
                          label="Moneda"
                          labelCol={{ span: 8 }}
                          wrapperCol={{ span: 16 }}
                          initialValue="60c7e4396465ad440c41c15a"
                        >
                          <SelectItem
                            onChange={(value) => this.aplicarMoneda(value)}
                            placeholder="Moneda"
                          >
                            {this.state.objetoMonedas}
                          </SelectItem>
                        </FormItem>
                        <FormItem noStyle shouldUpdate={(prev, curr) => prev.monedaId !== curr.monedaId}>
                          {({ getFieldValue }) => {
                            const monedaId = getFieldValue("monedaId");
                            return monedaId !== "60c7e4396465ad440c41c15a" ? (
                              <FormItem
                                required
                                number
                                margin
                                label="T. Cambio"
                                name="tipoDeCambio"
                                type="number"
                                initialValue={1}
                                labelCol={{ span: 8 }}
                                wrapperCol={{ span: 16 }}
                              >
                                <InputNumberItem
                                  dinero
                                  placeholder="T. Cambio"
                                />
                              </FormItem>
                            ) : (
                              <FormItem name="tipoDeCambio" initialValue={1} hidden>
                                <InputNumberItem />
                              </FormItem>
                            );
                          }}
                        </FormItem>
                      </>
                    ),
                  },
                ]}
                tabsConfig={{
                  tabs: [
                    {
                      key: "insumos",
                      label: "Insumos",
                      listName: "insumos",
                      columns: this.getInsumosColumns(),
                      renderRow: this.renderInsumoRow,
                      renderHeader: () => (
                        <Row justify="end" style={{ marginBottom: "10px", marginRight: "15px" }} gutter={10}>
                          <Col span={14} style={{ transform: "translateX(-20px)" }}>
                            <Input.Search
                              prefix={<SearchOutlined style={{ color: '#bfbfbf' }} />}
                              placeholder="Buscar por descripción, código, clave o cód. barras..."
                              allowClear
                              style={{ marginRight: 10, width: "100%", borderRadius: 8 }}
                              enterButton={
                                <Button
                                  type="primary"
                                  style={{
                                    background: "#00BFD6",
                                    borderColor: "#00BFD6"
                                  }}
                                >
                                  Buscar
                                </Button>
                              }
                              size="middle"
                              onSearch={this.buscarInsumo}
                              onChange={(e) => {
                                if (!e.target.value) this.setState({ insumoResaltado: null });
                              }}
                            />
                          </Col>
                          <Col>
                            <Space>
                              <Typography.Text style={{ fontSize: "12px", color: "#888" }}>
                                Mostrar detalles:
                              </Typography.Text>
                              <Switch
                                size="small"
                                checked={this.state.mostrarDetalles}
                                onChange={(checked) => this.setState({ mostrarDetalles: checked })}
                              />
                            </Space>
                          </Col>
                          <Col>
                            <Space>
                              <Typography.Text style={{ fontSize: "12px", color: "#888" }}>
                                Ver como sistema:
                              </Typography.Text>
                              <Switch
                                size="small"
                                checked={this.state.verInsumosComoSistema}
                                onChange={(checked) => this.setState({ verInsumosComoSistema: checked })}
                              />
                            </Space>
                          </Col>
                          <Col>
                            <Space>
                              <Typography.Text style={{ fontSize: "12px", color: "#888" }}>
                                Agrupar por familia:
                              </Typography.Text>
                              <Switch
                                size="small"
                                checked={this.state.agruparPorFamilia}
                                onChange={(checked) => this.setState({ agruparPorFamilia: checked })}
                              />
                            </Space>
                          </Col>

                        </Row>
                      ),
                      agrupacion: this.agrupacionPorFamilia(),
                      renderFooter: ({ add, fields }) => (
                        <FormItem noStyle>
                          <Space>
                            <ButtonItem
                              style={{
                                marginTop: 10,
                                marginBottom: 10,
                                justifySelf: fields.length > 0 ? "left" : null,
                                width: fields.length > 0 ? "auto" : null,
                              }}
                              type="primary"
                              onClick={() => add()}
                              hotkey="alt+a"
                              block
                              cyan
                              icon={<PlusOutlined />}
                            >
                              Agregar Insumo
                            </ButtonItem>
                            {/* <ButtonItem
                              style={{ marginTop: 10, marginBottom: 10 }}
                              icon={<FileExcelOutlined />}
                              onClick={() => {
                                const proveedorId = this.formRef.current.getFieldValue("proveedorId");
                                if (!proveedorId) {
                                  message.warning("Selecciona primero un proveedor");
                                  return;
                                }
                                this.setState({ modalCargarExcelVisible: true });
                              }}
                            >
                              Cargar Excel
                            </ButtonItem> */}
                          </Space>
                        </FormItem>
                      ),
                    },
                  ],
                }}
                observacionesConfig={{
                  observaciones: {
                    value: this.formRef.current?.getFieldValue("observaciones"),
                    onSave: (newValue) => {
                      this.formRef.current?.setFieldsValue({ observaciones: newValue });
                      this.forceUpdate();
                    },
                  },
                  observaciones2: {
                    label: "Observaciones Internas",
                    tooltip: "Estas observaciones no se imprimirán.",
                    value: this.formRef.current?.getFieldValue("observaciones2"),
                    onSave: (newValue) => {
                      this.formRef.current?.setFieldsValue({ observaciones2: newValue });
                      this.forceUpdate();
                    },
                  },
                  ...this.getObservacionesConfig(),
                }}
                actionButtons={
                  <Space>
                    {this.props.autorizacionesRapidas && (
                      <Tooltip title="Si no puedes aprobar la orden tú mismo, se enviará sola una solicitud a los autorizadores configurados en cuanto se guarde.">
                        <Checkbox
                          checked={this.state.enviarAprobacionAutomatica}
                          onChange={(e) => this.setState({ enviarAprobacionAutomatica: e.target.checked })}
                        >
                          <span style={{ fontSize: "12px", color: "#888" }}>
                            Enviar automáticamente a aprobación
                          </span>
                        </Checkbox>
                      </Tooltip>
                    )}
                    <ButtonItem type="primary" htmlType="submit" hotkey="shift+a" cyanB>
                      Agregar
                    </ButtonItem>

                  </Space>
                }
              />
              <FormItem name="observaciones" hidden><TextAreaItem /></FormItem>
              <FormItem name="observaciones2" hidden><TextAreaItem /></FormItem>
            </Form>
          </Spin>
        </div>
        <ElegirTipoDeProveedor
          visible={this.state.modalElegirTipoDeProveedor}
          id={this.state.modalElegirTipoDeProveedorId}
          nombre={this.state.modalElegirTipoDeProveedorNombre}
          cerrarElegirTipoDeProveedor={this.cerrarElegirTipoDeProveedor.bind(
            this
          )}
        />
        <MandarCorreoOrdenDeCompra
          visible={this.state.modalCorreo}
          cerrarMandarCorreoOrdenDeCompra={this.cerrarModalCorreo.bind(this)}
          id={this.state.modalCorreoId}
        />
        <ElegirObservaciones
          visible={this.state.modalObservaciones}
          cerrarElegirObservaciones={this.cerrarObservaciones.bind(this)}
          observaciones={this.state.modalObservacionesObservaciones}
          observacionesPasadas={
            this.state.modalObservacionesObservacionesPasadas
          }
          observacionesXml={this.state.modalObservacionesObservacionesXml}
          noXml
          proveedorIdActual={this.state.proveedorIdActual} 
          nombreProveedorActual={this.state.nombreProveedorActual}
        />
        
        <AsignarInsumo
          visible={this.state.modalAsignarInsumoVisible}
          cerrarAsignarInsumo={this.cerrarModalAsignarInsumo}
          proveedor={this.state.proveedorSeleccionado} 
          empresaId={this.props.empresaId}
          headersToken={this.props.headersToken}
          insumoIdPrecargado={this.state.insumoIdRelacionando}
          insumoDataPrecargado={this.state.insumoDataRelacionando} 
        />

        <ModalInsumosSinRelacion
          visible={this.state.modalSinRelacionVisible}
          insumosSinRelacion={this.state.insumosSinRelacion}
          onCancel={() => this.setState({ modalSinRelacionVisible: false })}
          onRelacionarClick={(item) => {
            this.setState({
              insumoIdRelacionando: item.insumoId,
              insumoDataRelacionando: item,
              modalAsignarInsumoVisible: true,
            });
          }}
        />

        <ModalCargarExcelOC
          visible={this.state.modalCargarExcelVisible}
          onCancel={() => this.setState({ modalCargarExcelVisible: false })}
          empresaId={this.props.empresaId}
          headersToken={this.props.headersToken}
          proveedorId={this.formRef.current?.getFieldValue("proveedorId")}
          onConfirmar={this.cargarInsumosDesdeExcel}
        />

        <DisponibilidadInsumoModal
          visible={this.state.modalDisponibilidadVisible}
          onClose={this.cerrarDisponibilidad}
          insumoId={this.state.insumoSeleccionadoDisponibilidad.id}
          nombreInsumo={this.state.insumoSeleccionadoDisponibilidad.nombre}
          headersToken={this.props.headersToken}
          empresaId={this.props.empresaId}
          proyectoId={this.state.insumoSeleccionadoDisponibilidad.proyectoId}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    autorizacionesRapidas: state.empresa.autorizacionesRapidas,
    verComoSistemaOCPorDefecto: state.empresa.verComoSistemaOCPorDefecto,
    imprimirObservacionesOCPorDefecto: state.empresa.imprimirObservacionesOCPorDefecto,
    escuela: state.empresa.escuela,
  };
};

export default connect(mapStateToProps)(AgregarOrdenDeCompra);